import { authorizedFetch } from '../utils';
import theme from '../theme';

const {
  brand500,
  brand600,
  navDev,
  navDevHover,
  navUat,
  navUatHover
} = theme.global.colors;

export const platforms = {
  PXP: 'pxp',
  CDP: 'cdp'
};

export const environments = {
  DEV: 'dev',
  UAT: 'uat',
  PROD: 'prod',
  CDP_TEST: 'cdptest',
  CDP_PROD: 'cdpprod'
};

let environmentConfig = null;

export const getConfig = () => {
  return authorizedFetch('/api/environmentConfig')
    .then(response => {
      environmentConfig = response;
    })
    .catch(e => {
      console.log(e);
    });
};

export const getEnvironmentConfig = () => environmentConfig;

export const getEnvironmentTheme = () => {
  switch (environmentConfig?.environment) {
    case environments.DEV:
      return {
        navColor: navDev,
        navHoverColor: navDevHover,
        badge: 'DEV',
        faviconHref: '/favicon-dev.ico'
      };
    case environments.UAT:
      return {
        navColor: navUat,
        navHoverColor: navUatHover,
        badge: 'UAT',
        faviconHref: '/favicon-uat.ico'
      };
    default:
      return {
        navColor: brand500,
        navHoverColor: brand600,
        badge: null,
        faviconHref: '/favicon.ico'
      };
  }
};

//build a function that we don't need to resolve as a promise b/c its a pain to refactor everything here
export const isApplicable = ({ environment, platform }) => {
  //component should be rendered only on a certain environment
  if (environment && environment !== environmentConfig?.environment) {
    return false;
  }

  //component should be rendered only on a certain platform
  if (platform && platform !== environmentConfig?.platform) {
    return false;
  }

  return true;
};
